import {
  CATEGORY_TYPE_OPTIONS,
  STATUS_FILTER,
} from "../../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");

export const basicFormData = () => ({
  inputData: {
    material_type: "",
    name: "",
    descriptions: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "category_masters",
    schema: schema,
    inputData: {
      type: "",
      name: "",
      descriptions: "",
      created_by: "",
      updated_by: "",
      is_active: true,
    },
    moduleWhereCondition: {
      is_active: true,
    },
  };

  const navigatePage = { back: "/category-list" };

  const headerName = "Category";

  const validationType = "CategoryCreate";
  const createEndpoint = "/updaterelationaldata";
  const updateEndpoint = "/updaterelationaldata";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = (type) => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "category_masters",
    schema: schema,
  };

  const columnData = [
    { label: "Sr. No", value: "index" },
    { label: "Type", value: "material_type" },
    { label: "Category Name", value: "name" },
    { label: "Descriptions", value: "descriptions" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/category-create",
    edit: "/category-create",
    view: "/category-view",
  };

  const searchfields = ["name", "descriptions"];

  const headerName = "Category";
  const endpoint = "/getRecords";
  const exportFileName = "CategoryData.xlsx";

  const filterConfig = [
    { key: "type", label: "Type", width: 160, options: CATEGORY_TYPE_OPTIONS },
    STATUS_FILTER,
  ];

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

// export const exportPageData = {
//     modelName: "category_masters",
//     schema:schema,
//     whereCondition: {
//         role_type: { in: [1] },
//     },

//     // relations: [
//     //     {
//     //         module: "role_masters",
//     //         moduleAs: "createdBy",
//     //     },
//     //     {
//     //         module: "role_masters",
//     //         moduleAs: "updatedBy",
//     //     },
//     //     {
//     //         module: "role_masters",
//     //         moduleAs: "subcontractor",
//     //     },
//     //     {
//     //         module: "role_masters",
//     //         moduleAs: "role_masters",
//     //     },
//     //     {
//     //         module: "company_masters",
//     //         moduleAs: "company_masters",
//     //     },
//     // ],
//     pagination: { page: 1, pageSize: 10000 },
// };
